import * as Mod1 from "./discourse/components/category-expert-post-indicator";
import * as Mod2 from "./discourse/components/category-experts-approve-button";
import * as Mod3 from "./discourse/components/category-experts-form-kit-settings";
import * as Mod4 from "./discourse/components/category-experts-settings";
import * as Mod5 from "./discourse/components/category-experts-unapprove-button";
import * as Mod6 from "./discourse/components/endorsement-button";
import * as Mod7 from "./discourse/components/is-question-checkbox";
import * as Mod8 from "./discourse/components/modal/endorse-user/endorsement-checkboxes";
import * as Mod9 from "./discourse/components/modal/endorse-user/index";
import * as Mod10 from "./discourse/components/modal/expert-group-chooser";
import * as Mod11 from "./discourse/components/reviewable/category-expert-suggestion";
import * as Mod12 from "./discourse/connectors/above-review-filters/endorsed-username-to-filters.gjs";
import * as Mod13 from "./discourse/connectors/advanced-search-options-below/category-experts-search-fields.gjs";
import * as Mod14 from "./discourse/connectors/category-custom-settings/category-experts-settings.gjs";
import * as Mod15 from "./discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox.gjs";
import * as Mod16 from "./discourse/connectors/composer-fields/is-category-expert-question.gjs";
import * as Mod17 from "./discourse/connectors/topic-category/is-question-indicator.gjs";
import * as Mod18 from "./discourse/connectors/topic-list-after-title/category-experts-indicator.gjs";
import * as Mod19 from "./discourse/connectors/user-card-additional-buttons/endorsement-button.gjs";
import * as Mod20 from "./discourse/connectors/user-profile-controls/endorsement-button.gjs";
import * as Mod21 from "./discourse/helpers/category-expert-question-indicator";
import * as Mod22 from "./discourse/initializers/category-experts-post-decorator";
import * as Mod23 from "./discourse/initializers/category-experts-search";
import * as Mod24 from "./discourse/pre-initializers/extend-for-category-experts";
const compatModules = {
  "discourse/components/category-expert-post-indicator": Mod1,
  "discourse/components/category-experts-approve-button": Mod2,
  "discourse/components/category-experts-form-kit-settings": Mod3,
  "discourse/components/category-experts-settings": Mod4,
  "discourse/components/category-experts-unapprove-button": Mod5,
  "discourse/components/endorsement-button": Mod6,
  "discourse/components/is-question-checkbox": Mod7,
  "discourse/components/modal/endorse-user/endorsement-checkboxes": Mod8,
  "discourse/components/modal/endorse-user/index": Mod9,
  "discourse/components/modal/expert-group-chooser": Mod10,
  "discourse/components/reviewable/category-expert-suggestion": Mod11,
  "discourse/connectors/above-review-filters/endorsed-username-to-filters": Mod12,
  "discourse/connectors/advanced-search-options-below/category-experts-search-fields": Mod13,
  "discourse/connectors/category-custom-settings/category-experts-settings": Mod14,
  "discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox": Mod15,
  "discourse/connectors/composer-fields/is-category-expert-question": Mod16,
  "discourse/connectors/topic-category/is-question-indicator": Mod17,
  "discourse/connectors/topic-list-after-title/category-experts-indicator": Mod18,
  "discourse/connectors/user-card-additional-buttons/endorsement-button": Mod19,
  "discourse/connectors/user-profile-controls/endorsement-button": Mod20,
  "discourse/helpers/category-expert-question-indicator": Mod21,
  "discourse/initializers/category-experts-post-decorator": Mod22,
  "discourse/initializers/category-experts-search": Mod23,
  "discourse/pre-initializers/extend-for-category-experts": Mod24,
};
export { compatModules };
export default compatModules;
